import React from "react";
import BontonQrMappingList from "./BontonQrMappingList";

const DemappedList = () => (
    <BontonQrMappingList status={0} title="Demapped List" />
);

export default DemappedList;
